<template>
    <div>
        <b-card class="shadow mb-5 ml-md-5 mr-md-5 ml-0 mr-0" v-if="!stub">

            <div class="d-flex flex-column flex-xl-row w-100 align-items-start justify-content-start mb-5">

                <div class="d-flex flex-grow-1 align-items-xl-center mb-4 mb-xl-0 flex-column flex-sm-row w-100">
                    <b-button
                            variant="link"
                            class="flex-grow-0 d-flex align-items-center text-secondary flex-nowrap p-0 mb-4"
                            @click="back()">
                        <b-icon icon="chevron-left" class="mr-2"/>
                        <span>Назад</span>
                    </b-button>

                    <div class="d-flex flex-grow-1 align-items-baseline justify-content-center flex-column flex-sm-row mb-4"
                         :key="objectKey + '-header'">
                        <span class="h3 mb-2 mb-lg-0" v-if="!object.id">Контракт</span>
                        <span class="h3 mb-2 mb-lg-0 mr-3" v-else>{{ header }}</span>
                        <sup><small v-if="!object.id" class="text-secondary ml-2">Новый</small></sup>
                    </div>
                </div>
            </div>

            <div id="form" class="d-flex flex-wrap">

                <form-field  class="col-xs-12 col-lg-8 col-xl-8 mb-3"
                             :class="{required: getAbility('number')}"
                             :label="getFieldLabel('number')"
                             :editable="getAbility('number')"
                             :value="object.number"
                             :feedback="liveFeedback('number')">
                    <template #field>
                        <b-form-input
                            id="number"
                            class="w-100"
                            type="text"
                            v-model="$v.form.number.$model"
                            :state="validateState('number')">
                        </b-form-input>
                    </template>
                </form-field>

                <form-field class="required col-xs-12 col-lg-6 mb-3"
                             :label="getFieldLabel('contractType')"
                             :editable="getAbility('contractType')"
                             :value="object.contractTypeText"
                             :feedback="liveFeedback('contractType')">
                    <template #field>
                        <radio-list id="contractType" name="contractType"
                                    v-model="form.contractType" :url="getContractTypesUrl"
                                    @radio-changed="onModelObjectRadioChanged"/>
                    </template>
                </form-field>

                <form-field :label="getFieldLabel('customer')"
                            class="col-xs-12 col-lg-6 mb-3"
                            :class="{required: getAbility('customer')}"
                            :editable="getAbility('customer') && canSelectCustomer"
                            :feedback="liveFeedback('customer')"
                            :value="object.customerObject ? object.customerObject.name : object.customer"
                            :key="objectKey + 'customer'">
                    <template #field>
                        <single-select name="customer"
                               v-model="form['customerObject']"
                               :url="getCustomersUrl"
                               :label="getFieldLabel('customer')"
                               :state="getValidationClass('customer')"
                               :initial-filters="customerFilters"
                               v-on:select-changed="onModelObjectSingleSelectChanged"
                               v-on:select-cleared="onModelObjectSingleSelectCleared" />
                    </template>
                </form-field>

                <form-field v-if="canSelectContractor()" :label="getFieldLabel('contractor')"
                            class="col-xs-12 col-lg-6 mb-3"
                            :class="{required: getAbility('contractor')}"
                            :editable="getAbility('contractor')"
                            :feedback="liveFeedback('contractor')"
                            :value="object.contractorObject ? object.contractorObject.name : object.contractor"
                            :key="objectKey + 'contractor'">
                    <template #field>
                        <single-select name="contractor"
                               v-model="form['contractorObject']"
                               :url="getContractorsUrl"
                               :label="getFieldLabel('contractor')"
                               :state="getValidationClass('contractor')"
                               :initial-filters="contractorFilters"
                               v-on:select-changed="onModelObjectSingleSelectChanged"
                               v-on:select-cleared="onModelObjectSingleSelectCleared" />
                    </template>
                </form-field>
                <div v-else class="col-5">
                </div>

                <form-field v-if="getAbility('validFrom')"
                    class="col-xs-12 col-lg-6 mb-3"
                    :editable="true"
                    :feedback="liveFeedback('validFrom')"
                    :value="object.validFrom"
                    :key="objectKey + 'validFrom'">
                    <template #field>
                        <date-time-picker class="required" ref="validFrom"
                              :title="getFieldLabel('validFrom')"
                              name="validFrom"
                              :show-timepicker="false"
                              :date-required="false"
                              :time-required="true"
                              :key="getValidFrom() + '-f'"
                              :initial-date-string="getValidFrom()"
                              :state="validateState('validFrom')"
                              @date-changed="onModelDateChanged" />
                    </template>
                </form-field>
                <form-field v-else class="col-sm-6 col-lg-4 col-xl-2 mb-3" :label="getFieldLabel('validFrom')">
                    <template #value>
                        <span class="d-flex flex-column">
                            <span>{{ object.validFromDate }}</span>
                            <span class="text-secondary">{{ object.validFromTime }}</span>
                        </span>
                    </template>
                </form-field>

                <form-field v-if="getAbility('validUntil')"
                    class="col-xs-12 col-lg-5 mb-3"
                    :editable="true"
                    :feedback="liveFeedback('validUntil')"
                    :value="object.validUntil"
                    :key="objectKey + 'validUntil'">
                    <template #field>
                        <date-time-picker
                              ref="validUntil"
                              :title="getFieldLabel('validUntil')"
                              name="validUntil"
                              :show-timepicker="false"
                              :date-required="false"
                              :time-required="true"
                              :key="getValidUntil() + '-u'"
                              :initial-date-string="getValidUntil()"
                              :state="validateState('validUntil')"
                              @date-changed="onModelDateChanged" />
                    </template>
                </form-field>
                <form-field v-else class="col-sm-6 col-lg-4 col-xl-2 mb-3" :label="getFieldLabel('validUntil')">
                    <template #value>
                        <span class="d-flex flex-column">
                            <span>{{ object.validUntilDate }}</span>
                            <span class="text-secondary">{{ object.validUntilTime }}</span>
                        </span>
                    </template>
                </form-field>

                <form-field  class="col-sm-6 col-lg-4 col-xl-2 mb-3"
                             :label="getFieldLabel('price')"
                             :editable="getAbility('price')"
                             :value="object.price"
                             :feedback="liveFeedback('price')">
                    <template #field>
                        <b-form-input
                            id="price"
                            class="w-100"
                            type="text"
                            v-model="$v.form.price.$model"
                            :state="validateState('price')">
                        </b-form-input>
                    </template>
                </form-field>


                <form-field  class="col-sm-6 col-lg-4 col-xl-2  mb-3"
                             :label="getFieldLabel('animalsLimit')"
                             :editable="getAbility('animalsLimit')"
                             :value="object.animalsLimit"
                             :feedback="liveFeedback('animalsLimit')">
                    <template #field>
                        <b-form-input
                            id="animalsLimit"
                            class="w-100"
                            type="text"
                            v-model="$v.form.animalsLimit.$model"
                            :state="validateState('animalsLimit')">
                        </b-form-input>
                    </template>
                </form-field>


            </div>

            <div class="col-12">
                <object-form-buttons :has-changes="hasChanges"
                     :object-exists="Boolean(object.id)"
                     @object-create="onCreate"
                     @object-update="updateObject"
                     @object-cancel-changes="cancelChanges" class="mb-5"/>
            </div>

        </b-card>

        <stub :failed-loading="failedLoading" v-else />

        <confirm-leave-modal ref="leaveDialog" :silent-leave="silentLeave" :leave-browser-confirm="hasChanges"/>
    </div>
</template>

<script>
import {ObjectComponentMixin} from "@/components/Forms/ObjectComponentMixin";
import FormField from "@/components/Forms/FormField";
import api from "@/api";
import {Contract} from "@/pages/AppPages/Catalogs/Contracts/contract";
import DateTimePicker from "@/components/Forms/DateTimePicker";
import ObjectFormButtons from "@/components/Forms/ObjectFormButtons";
import ConfirmLeaveModal from "@/components/Forms/ConfirmLeaveModal";
import {todayStr} from "@/utils/dateFormat";
import {mapGetters} from "vuex";
import SingleSelect from "@/components/Select/SingleSelect";
import Stub from "@/components/Stub.vue";
import RadioList from "@/components/Select/RadioList.vue";

export default {
    name: "ContractDetail",
    components: {RadioList, Stub, SingleSelect, ConfirmLeaveModal, ObjectFormButtons, DateTimePicker, FormField  },
    mixins: [ObjectComponentMixin],
    props: {
        contractId: null
    },
    data() {
        return {
            canSelectCustomer: true
        }
    },
    computed: {
        ...mapGetters(['userOrganization', 'userOrganizationId', 'isSuperuser', 'isMunicipalController']),
        getCustomersUrl() {
            return api.organizations.default.list();
        },
        getContractorsUrl() {
            return api.organizations.default.list();
        },
        getContractTypesUrl() {
            return api.contracts.types.list();
        },
        customerFilters() {
            return [{key: 'groups', value: 8}]
        },
        contractorFilters() {
            let contractorFilters = [{key: 'groups', value: 4}];
            if (this.form['customerObject'] !== undefined && Object.keys(this.form['customerObject']).length) {  // если выбран заказчик, фильтруем по муниципалитетам заказчика
                const municipalities = this.form['customerObject']['municipalities'];
                if (municipalities) {
                    for (const municipalityId of municipalities) {
                        contractorFilters.push({key: 'municipality', value: municipalityId})
                    }
                }
            }
            return contractorFilters
        }
    },
    methods: {
        getValidFrom() {
            return this.object.validFrom;
        },
        getValidUntil() {
            return this.object.validUntil;
        },
        canSelectContractor() {
            return Boolean(this.form['customer'])
        }
    },
    beforeMount() {
        this.objectClass = Contract;
        this.objectId = this.contractId ? this.contractId : this.$route.params.id;
        this.apiEntryPoint = api.contracts;
        this.backRoute = 'contractList';
        this.nextRoute = 'contractDetail';

        this.initObjectParams['validFrom'] = todayStr();

        if (this.isMunicipalController && !this.isSuperuser) {
            this.initObjectParams['customer'] = this.userOrganizationId;
            this.initObjectParams['customerObject'] = this.userOrganization;
            this.canSelectCustomer = false;
        }
    },
    mounted() {
        this.onMount();
        this.resetForm();
    },
}
</script>

<style scoped>

</style>